var React = require('react');

function CustomAccessRulesLockIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7 31c0-5.194 2.33-9.844 6-12.962V11c0-6.075 4.925-11 11-11s11 4.925 11 11v1h-4v-1a7 7 0 1 0-14 0v4.504A16.939 16.939 0 0 1 24 14c9.389 0 17 7.611 17 17s-7.611 17-17 17S7 40.389 7 31zm21-4c0 1.38-.698 2.596-1.76 3.315L28 40h-8l1.76-9.685A4 4 0 1 1 28 27z","fill":"#8D6CFF"}));
}

CustomAccessRulesLockIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = CustomAccessRulesLockIcon;

CustomAccessRulesLockIcon.default = CustomAccessRulesLockIcon;
